import { render, staticRenderFns } from "./checked.vue?vue&type=template&id=55b71004&scoped=true"
import script from "./checked.vue?vue&type=script&lang=js"
export * from "./checked.vue?vue&type=script&lang=js"
import style0 from "./checked.vue?vue&type=style&index=0&id=55b71004&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b71004",
  null
  
)

export default component.exports